export default "__VITE_ASSET__DgTQuTMV__"